import { getAuthAxiosBackend } from "../../helpers/axios"

class PresidentServices{

    get(id){
        return getAuthAxiosBackend().get('presidents/' + id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('presidents', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('presidents/' + id)
    }
}

export default new PresidentServices()